import { createAction, props } from '@ngrx/store';
import {
  PrinterControllerGetThresholds$Params,
  ReplacementThresholdControllerDelete$Params,
  ReplacementThresholdControllerFind$Params,
  ReplacementThresholdControllerSetTraking$Params,
} from '../../../api/functions';
import { ILoaderActionPayload } from '../models/loader.model';
import { ReplacementThresholdListResponse, SetThresholdResponse, ThresholdsResponse } from '../../../api/models';

export const thresholdActions = {
  loadAll: createAction('threshold/all/load', props<PrinterControllerGetThresholds$Params>()),
  loadAllDone: createAction('threshold/all/done', props<{ state: ILoaderActionPayload; data?: ThresholdsResponse }>()),
  loadThreshold: createAction('loadThreshold/threshold/load', props<ReplacementThresholdControllerFind$Params>()),
  loadThresholdDone: createAction(
    'loadThreshold/threshold/done',
    props<{ state: ILoaderActionPayload; data?: ReplacementThresholdListResponse }>(),
  ),
  setTraking: createAction('setTraking/load', props<ReplacementThresholdControllerSetTraking$Params>()),
  setTrakingDone: createAction(
    'setTraking/done',
    props<{ state: ILoaderActionPayload; data?: SetThresholdResponse }>(),
  ),
  setTrakingSetState: createAction('setTraking/setState', props<{ state: ILoaderActionPayload }>()),
  deleteThreshold: createAction('deleteThreshold/threshold/load', props<ReplacementThresholdControllerDelete$Params>()),
  deleteThresholdDone: createAction('deleteThreshold/threshold/done', props<{ state: ILoaderActionPayload }>()),
};
